var map = {
	"./_MG_1112.jpg": 25064,
	"./_MG_1125.jpg": 85614,
	"./_MG_1174.jpg": 79963,
	"./_MG_1201.jpg": 91111,
	"./_MG_1328.jpg": 24026,
	"./_MG_1335.jpg": 26964,
	"./_MG_1338.jpg": 24464,
	"./_MG_1358.jpg": 70349,
	"./_MG_1368.jpg": 60958,
	"./_MG_1377.jpg": 3384,
	"./_MG_1380.jpg": 61380,
	"./_MG_3850.jpg": 46534,
	"./_MG_5300.jpg": 30466,
	"./_MG_8493.jpg": 35825
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80249;